module.exports = __webpack_public_path__ + "static/media/news_gothic_condensed_bt.f865e644.woff2";